export const PHONE_OPTIONS = [
  { value: 'Soft Phone', label: 'Soft Phone' },
  { value: 'Desk Phone', label: 'Desk Phone' },
];

export const DEFAULT_DEVICE = 'default';

export const AGENT_PREFERENCES = { locale: 'en_US' };
